const baseUrl = '/propertyutility';
export const propertyUtilityRoutes = {
  baseUrl: "".concat(baseUrl),
  gwdHistory: "".concat(baseUrl, "/gwd-history"),
  propertyUtilities: propertyId => "".concat(baseUrl, "/").concat(propertyId),
  propertyUtilityById: propertyUtilityId => "".concat(baseUrl, "/").concat(propertyUtilityId),
  propertyUtilitiesConfiguration: propertyId => "".concat(baseUrl, "/").concat(propertyId, "/utility-configuration"),
  propertyUtilitiesAdd: propertyId => "".concat(baseUrl, "/").concat(propertyId, "/utilities"),
  propertyUtility: (propertyId, utilityId) => "".concat(baseUrl, "/").concat(propertyId, "/utilities/").concat(utilityId),
  propertyUtilityBatch: "".concat(baseUrl, "/batch"),
  propertyUtilityBatchUpdate: "".concat(baseUrl, "/v2"),
  propertyUtilityInfo: "".concat(baseUrl, "/info"),
  submeterConfig: propertyUtilityId => "".concat(baseUrl, "/").concat(propertyUtilityId, "/submeter-config"),
  submeterConfigV2: propertyUtilityId => "".concat(baseUrl, "/").concat(propertyUtilityId, "/submeter-config-v2"),
  csvColumnMap: propertyUtilityId => "".concat(baseUrl, "/").concat(propertyUtilityId, "/csv-column-map")
};